import { Button, ButtonStyles, LoaderType, NextgenImage, Theme } from '@nextgen-web-framework/all';
import { EmptyResultProps } from './types/propTypes';
import styles from './EmptyResult.module.scss';

const EmptyResult = ({ noResultLabels, goToShop }: EmptyResultProps) => (
  <div className={styles['empty-result-container']}>
    <div className={styles['empty-result-component']}>
      <div className={styles['empty-result-component-icon']}>
        <NextgenImage
          loaderType={LoaderType.WEBFONTS}
          isRelativeURL
          alt="No search result"
          src="/images/NoSearchResult.svg"
        />
      </div>
      <div className={styles['empty-result-component-txt']}>
        <div className={styles['empty-result-component-txt1']} data-testid="empty-result-component-txt1">
          {noResultLabels['emptyResultTxt1']}
        </div>
        <div className={styles['empty-result-component-txt2']} data-testid="empty-result-component-txt2">
          {noResultLabels['emptyResultTxt2']}
        </div>
      </div>
      {noResultLabels['emptyResultBtnLabel'] && (
        <div className={styles['empty-result-component-shopping-btn']}>
          <Button
            id={styles['empty-result-component-continue-shopping-btn']}
            onClick={goToShop}
            title={noResultLabels['emptyResultBtnLabel']}
            tabIndex={0}
            buttonStyle={ButtonStyles.SOLID}
            theme={Theme.BLACK}
            data-testid="empty-result-component-continue-shopping-btn"
          />
        </div>
      )}
    </div>
  </div>
);

export default EmptyResult;
